import Application from '../Application';
import Computers from './Computers';
import MonitorScreen from './MonitorScreen';
import AudioManager from '../Audio/AudioManager';
export default class World {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        // Wait for resources
        this.resources.on('ready', () => {
            // Computers has to come first, it measures the screen that
            // MonitorScreen and the camera keyframes anchor themselves to.
            this.computers = new Computers();
            this.monitorScreen = new MonitorScreen();
            this.audioManager = new AudioManager();
        });
    }
    update() {
        if (this.computers)
            this.computers.update();
        if (this.monitorScreen)
            this.monitorScreen.update();
        if (this.audioManager)
            this.audioManager.update();
    }
}
